<div class="row">
    <div class="col-12">
        <h4 class="fw-bold">
            {{ "national_strategies.title" | translate }}
            <span class="fw-light mx-1">
                @if (displayLabel) {
                    - {{ displayLabel }}
                }
            </span>
        </h4>
    </div>

    <div class="col-12" [formGroup]="nsForm">
        <adaa-form-steps
            [showSaveButton]="showSave()"
            [showFinishButton]="showFinish()"
            [tabs]="tabs"
            (currentTab)="activeTab.set($event)"
            (submitClicked)="save($event)"
            (cancelClicked)="goBack()"
        >
            <div class="tab-pane fade" id="tab-0" role="tabpanel" [class.show]="activeTab() === 0" [class.active]="activeTab() === 0">
                <div class="bg-card shadow-md rounded p-2 mb-2">
                    <div class="row">
                        @if (pageMode() !== PageMode.create) {
                            <div class="col-12">
                                <adaa-form-input
                                    controlName="refCode"
                                    formControlName="refCode"
                                    [invalid]="nsForm.get('refCode')?.touched! && nsForm.get('refCode')?.invalid!"
                                    [label]="'common.form.label.refcode' | translate"
                                    [setValidator]="validations()!"
                                />
                            </div>
                        }
                    </div>
                    <div class="row">
                        <div class="col-sm-6 col-xs-12">
                            <adaa-form-input
                                controlName="nameAE"
                                formControlName="nameAE"
                                [invalid]="nsForm.get('nameAE')?.touched! && nsForm.get('nameAE')?.invalid!"
                                [label]="'common.form.label.nameAE' | translate"
                                [setValidator]="validations()!"
                            />
                        </div>
                        <div class="col-sm-6 col-xs-12">
                            <adaa-form-input
                                controlName="nameEN"
                                formControlName="nameEN"
                                [invalid]="nsForm.get('nameEN')?.touched! && nsForm.get('nameEN')?.invalid!"
                                [label]="'common.form.label.nameEN' | translate"
                                [setValidator]="validations()!"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 col-xs-12">
                            <adaa-form-input
                                controlName="dscAE"
                                formControlName="dscAE"
                                [invalid]="nsForm.get('dscAE')?.touched! && nsForm.get('dscAE')?.invalid!"
                                [label]="'common.form.label.descriptionAE' | translate"
                                [setValidator]="validations()!"
                                [isTextArea]="true"
                            />
                        </div>
                        <div class="col-sm-6 col-xs-12">
                            <adaa-form-input
                                controlName="dscEN"
                                formControlName="dscEN"
                                [invalid]="nsForm.get('dscEN')?.touched! && nsForm.get('dscEN')?.invalid!"
                                [label]="'common.form.label.descriptionEN' | translate"
                                [setValidator]="validations()!"
                                [isTextArea]="true"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 col-xs-12">
                            <adaa-form-input-date
                                controlName="startDate"
                                formControlName="startDate"
                                [invalid]="nsForm.get('startDate')?.touched! && nsForm.get('startDate')?.invalid!"
                                [label]="'common.form.label.start_date' | translate"
                                [setValidator]="validations()!"
                            />
                        </div>
                        <div class="col-sm-6 col-xs-12">
                            <adaa-form-input-date
                                controlName="endDate"
                                formControlName="endDate"
                                [invalid]="nsForm.get('endDate')?.touched! && nsForm.get('endDate')?.invalid!"
                                [label]="'common.form.label.end_date' | translate"
                                [setValidator]="validations()!"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 col-xs-12">
                            <adaa-form-dropdown
                                controlName="entityId"
                                formControlName="entityId"
                                [invalid]="nsForm.get('entityId')?.touched! && nsForm.get('entityId')?.invalid!"
                                [label]="'national_projects.accountable_entity' | translate"
                                [setValidator]="validations()!"
                                [options]="entities()"
                                [clearable]="true"
                                (inputChanges)="entityIdChanged($event)"
                            />
                        </div>
                        <div class="col-sm-6 col-xs-12">
                            <adaa-form-dropdown
                                controlName="owner"
                                formControlName="owner"
                                [invalid]="nsForm.get('owner')?.touched! && nsForm.get('owner')?.invalid!"
                                [label]="'common.form.label.owner' | translate"
                                [setValidator]="validations()!"
                                [options]="owners()"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 col-xs-12">
                            <adaa-form-dropdown
                                controlName="strategyOwnerGroup"
                                formControlName="strategyOwnerGroup"
                                [invalid]="nsForm.get('strategyOwnerGroup')?.touched! && nsForm.get('strategyOwnerGroup')?.invalid!"
                                [label]="'national_strategies.strategic_owner_group' | translate"
                                [setValidator]="validations()!"
                                [options]="strategyOwnerGroups()"
                            />
                        </div>
                        <div class="col-sm-6 col-xs-12 d-flex align-items-center mt-3">
                            <adaa-form-checkbox
                                controlName="available"
                                formControlName="available"
                                [label]="'common.form.label.available' | translate"
                                [checkboxMode]="'yesNo'"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" id="tab-1" role="tabpanel" [class.show]="activeTab() === 1" [class.active]="activeTab() === 1">
                <div class="bg-card shadow-md rounded p-2 mb-2">
                    <div class="row">
                        <div class="col-12">
                            <adaa-data-table
                                #subDirectionsTable
                                titleHeader="national_strategies.obj_enabler"
                                [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.SUB_GOV_DIR"
                                [isLocalData]="true"
                                [localData]="filteredSubDirections"
                                [enableViewAction]="false"
                                [enableActionsCell]="pageMode() !== PageMode.view"
                                [enableAdd]="pageMode() !== PageMode.view"
                                [enableEditAction]="pageMode() !== PageMode.view"
                                [enableDeleteAction]="pageMode() !== PageMode.view"
                                [enableExport]="false"
                                (addNewClicked)="addObjectiveEnabler()"
                                (actionClicked)="manageObjectiveEnabler($event)"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" id="tab-1" role="tabpanel" [class.show]="activeTab() === 2" [class.active]="activeTab() === 2">
                <div class="bg-card shadow-md rounded p-2 mb-2">
                    <div class="row">
                        <div class="col-12">
                            <adaa-form-dropdown
                                controlName="ntKpiId"
                                formControlName="ntKpiId"
                                [clearable]="true"
                                [invalid]="nsForm.get('ntKpiId')?.touched! && nsForm.get('ntKpiId')?.invalid!"
                                [label]="'breadcrumbs.ntkpi_module.list' | translate"
                                [setValidator]="validations()!"
                                [options]="ntKpis()"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </adaa-form-steps>
    </div>
</div>
